// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--2z7jS";
export var banner__text = "Banner-module--banner__text--b-jMU";
export var fadeOutAnimation = "Banner-module--fadeOutAnimation--1HqvO";
export var fadeInAnimation = "Banner-module--fadeInAnimation--1la9r";